import { render, staticRenderFns } from "./RationsTableMobile.vue?vue&type=template&id=a5bcd18c&lang=pug"
import script from "./RationsTableMobile.vue?vue&type=script&lang=js"
export * from "./RationsTableMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports